import React, { useState, useMemo } from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

export default function ListingImageGrid({ images }) {
    const [mainIndex, setMainIndex] = useState(0);
    const [fade, setFade] = useState(false);

    const thumbnails = useMemo(() => {
        return images.slice(1, 5);
    }, [images]);

    const cycleImages = (direction) => {
        setFade(true);
        setTimeout(() => {
            const total = images.length;
            const nextIndex = (mainIndex + (direction === "right" ? 1 : -1) + total) % total;
            setMainIndex(nextIndex);
            setFade(false);
        }, 200);
    };

    const mainImage = images[mainIndex];
    const isFirstImage = mainIndex === 0;
    const imageNumberDisplay = `${mainIndex + 1}/${images.length}`;

    return (
        <>
            <style>{`
                .listing-grid {
                    display: grid;
                    grid-template-columns: 2fr 1fr 1fr;
                    grid-template-rows: repeat(2, 250px);
                    gap: 8px;
                    width: 100%;
                    max-width: 100%;
                }

                .image-container {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    border-radius: 6px;
                }

                .image-container img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    object-position: center;
                    display: block;
                    border-radius: 6px;
                    cursor: pointer;
                }

                .main-image {
                    opacity: 1;
                    transition: opacity 0.4s ease-in-out;
                }

                .main-image.fade-out {
                    opacity: 0.3;
                }

                .listing-grid .image-container:not(:nth-child(1))::after {
                    content: '';
                    position: absolute;
                    inset: 0;
                    background: rgba(255, 255, 255, 0.2);
                    opacity: 0;
                    transition: opacity 0.3s ease;
                    border-radius: 6px;
                    pointer-events: none;
                }

                .listing-grid .image-container:not(:nth-child(1)):hover::after {
                    opacity: 1;
                }

                .listing-grid .image-container:not(:nth-child(1)) img {
                    transition: transform 2s ease;
                }

                .listing-grid .image-container:not(:nth-child(1)):hover img {
                    transform: scale(1.05);
                }

                .listing-grid .image-container:nth-child(1) {
                    grid-column: 1 / span 1;
                    grid-row: 1 / span 2;
                }

                .listing-grid .image-container:nth-child(2) {
                    grid-column: 2 / span 1;
                    grid-row: 1 / span 1;
                }

                .listing-grid .image-container:nth-child(3) {
                    grid-column: 3 / span 1;
                    grid-row: 1 / span 1;
                }

                .listing-grid .image-container:nth-child(4) {
                    grid-column: 2 / span 1;
                    grid-row: 2 / span 1;
                }

                .listing-grid .image-container:nth-child(5) {
                    grid-column: 3 / span 1;
                    grid-row: 2 / span 1;
                }

                .arrow-overlay {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 48px;
                    height: 48px;
                    background: rgba(0, 0, 0, 0.4);
                    color: white;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    z-index: 2;
                    font-size: 24px;
                    transition: background 0.3s ease;
                }

                .arrow-overlay:hover {
                    background: rgba(0, 0, 0, 0.7);
                }

                .arrow-left {
                    left: 12px;
                }

                .arrow-right {
                    right: 12px;
                }

                .view-all-button {
                    position: absolute;
                    bottom: 12px;
                    right: 12px;
                    background-color: rgba(0, 0, 0, 0.7);
                    color: #fff;
                    padding: 8px 12px;
                    border-radius: 6px;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                    z-index: 3;
                    transition: background 0.3s ease;
                }

                .view-all-button:hover {
                    background-color: rgba(0, 0, 0, 0.9);
                }
            `}</style>

            <div style={{ position: 'relative' }}>
                <div className="listing-grid">
                    <div className="image-container shadow">
                        <img
                            src={mainImage}
                            alt="Main Listing"
                            className={`main-image ${fade ? "fade-out" : ""}`}
                        />
                        <div className="arrow-overlay arrow-left" onClick={() => cycleImages("left")}>
                            <ArrowBackIosNewIcon />
                        </div>
                        <div style={{
                            position: 'absolute',
                            top: '0.75rem',
                            left: '0.75rem',
                            backgroundColor: isFirstImage ? '#00a86b' : '#000',
                            color: '#fff',
                            padding: '0.25rem 0.6rem',
                            borderRadius: '0.5rem',
                            fontSize: '0.75rem',
                            fontWeight: '600',
                            zIndex: 2
                        }}>
                            {isFirstImage ? 'New 1 Day Ago' : imageNumberDisplay}
                        </div>
                        <div className="arrow-overlay arrow-right" onClick={() => cycleImages("right")}>
                            <ArrowForwardIosIcon />
                        </div>
                    </div>

                    {thumbnails.map((src, idx) => (
                        <div key={idx} className="image-container">
                            <img src={src} alt={`Thumbnail ${idx + 1}`} />
                        </div>
                    ))}
                </div>

                <div className="view-all-button">
                    View All 16 Images
                </div>
            </div>
        </>
    );
}